import {Route} from "./route";
import {NonEmbeddedPendingComponent} from "~/components/routerHelpers/nonEmbeddedPendingComponent";

export function PendingComponent() {
    return (
        <NonEmbeddedPendingComponent
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            route={Route as any}
            //
        />
    );
}
